<div class="container my-3 p-3 contactContent General" id="">
  <h3 class="page-title">{{'ContactSpeaker.PageTitle' | translate}}</h3>
  <p [innerHTML]= "'ContactSpeaker.PageDescription2' | translate"></p>
  <p [innerHTML]="'ContactSpeaker.Assistance' | translate"></p>
  <br>
  <h5>{{'ContactSpeaker.ContactInformation' | translate}}</h5>
  <hr>
  <form [formGroup]="contactForm" (ngSubmit)="submit()">
    <p class="form-label">{{'ContactAssessor.Name'|translate}}<span class="color-red">*</span></p>
    <div class="form-row" style="display: flex; gap: 10px; margin-bottom: 20px;">
      <div class="form-group" style="flex: 1;">
        <input type="text" formControlName="firstName" class="form-control" id="inputFirst-Speaker" placeholder="First">
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('firstName', 'required')">{{'ContactAssessor.Required'|translate}}</ng-container>
        </div>
      </div>
      <div class="form-group" style="flex: 1;">
        <input type="text" formControlName="lastName" class="form-control" id="inputLast-Speaker" placeholder="Last">
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('lastName', 'required')">{{ 'ContactAssessor.Required' | translate}}</ng-container>
        </div>
      </div>
    </div>
    
    <div class="form-group" style="margin-bottom: 20px;">
      <p class="form-label">{{ 'ContactAssessor.Email' | translate}} <span class="color-red">*</span></p>
      <input type="email" class="form-control" formControlName="email" placeholder="Email">
      <div class="invalid-feedback" style="display: block">
        <ng-container *ngIf="hasError('email', 'required')">{{ 'ContactAssessor.Required' | translate}} </ng-container>
      </div>
    </div>
    <p class="form-label">{{ 'ContactAssessor.Phone' | translate}}  <span class="color-red">*</span></p>
    <div class="form-row" style="margin-bottom: 20px;">
      <div class="form-group col-12">
        <input class="form-control"  type="text" appPhoneMask  formControlName="phone" placeholder="(XXX) XXX-XXXX" id="inputPhone-Speaker"  >
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('phone', 'required')">{{ 'ContactAssessor.Required' | translate}}</ng-container>
        </div>
      </div>
    </div>

    <div class="form-row" style="display: flex; gap: 10px; margin-bottom: 20px;">
      <div class="form-group" style="flex: 1;">
        <label class="form-label">{{ 'ContactSpeaker.Organization' | translate}}</label>
        <input type="text" formControlName="organization" class="form-control" id="" >

      </div>
      <div style="flex: 1;">
        <label class="form-label">{{ 'ContactSpeaker.Title' | translate}}</label>
        <input type="text" formControlName="title" class="form-control" id="" >

      </div>

    </div>
    <p class="form-label">{{'ContactAssessor.Address'| translate}}</p>
    <app-certificate-address
    [parentFormGroup]="contactForm"
    streetNumber="number"
    streetDirection="direction"
    streetName="street"
    streetType="type"
    unitNumber="unit"
    city="city"
    zipCode="zipCode"
    
    >
    </app-certificate-address>

    <br>
    <h5>{{'ContactSpeaker.Event' | translate}}</h5>
    <hr>
    <div class="form-row date-from" style="display: flex; gap: 10px; margin-bottom: 20px;">
      <div class="form-group" style="flex: 1;">
        <label class="form-label date">{{ 'ContactSpeaker.Date' | translate}}</label>
        <input type="text" formControlName="date" placeholder="Select A Date" class="form-control" bsDatepicker [bsConfig]="bsConfig">
      </div>
      <div class="col-sm-6 col-md-3 form-group">
        <label  class="form-label date">{{ 'ContactSpeaker.Day' | translate}}</label>
        <select formControlName="day" class="form-select" placeholder="Select Day">
          <option selected value="">Type..</option>
          <option>Monday</option>
          <option>Tuesday</option>
          <option>Wednesday</option>ß
          <option>Thursday</option>
          <option>Friday</option>
        </select>
      </div>
      <div class="col-sm-6 col-md-3 form-group time">
        <label  class="form-label ">{{ 'ContactSpeaker.Time' | translate}}</label>
        <timepicker id="timepicker" [showSpinners]="false" formControlName="time"></timepicker>
      </div>
    </div>
    <p class="form-label">{{'ContactSpeaker.Location'| translate}}</p>
    <app-certificate-address
    [parentFormGroup]="contactForm"
    streetNumber="locationNumber"
    streetDirection="locationDirection"
    streetName="locationStreet"
    streetType="locationType"
    unitNumber="locationUnit"
    city="locationCity"
    zipCode="locationZipCode"
    
    >
    </app-certificate-address>

    <div class="form-group" style="margin-bottom: 20px; margin-top: 20px;">
      <p class="form-label">{{ 'ContactSpeaker.CrossStreet' | translate}}</p>
      <input type="text" class="form-control" formControlName="crossStreet" placeholder="">
    </div>
    <div class="form-group" style="margin-bottom: 20px;">
      <p class="form-label">{{ 'ContactSpeaker.Purpose' | translate}}</p>
      <input type="text" class="form-control" formControlName="purpose" placeholder="">
    </div>
    <div class="form-group" style="margin-bottom: 20px;">
      <p class="form-label">{{ 'ContactSpeaker.Topic' | translate}}</p>
      <input formControlName="topic" type="text" class="form-control">
    </div>
    <div class="form-row">

    <div  class="form-row align-items-center" style="display: flex; gap: 10px; margin-bottom: 20px;">
      <div class="form-group" style="flex: 1;">
        <label class="form-label">{{ 'ContactSpeaker.NumberAttendees' | translate}}</label>
        <input type="text" formControlName="attendees" class="form-control" id="" >

      </div>
      <div class="col-md-4">
        <label class="form-label">{{ 'ContactSpeaker.SpeechTime' | translate}}</label>
        <input type="text" formControlName="speech" class="form-control" id="" >

      </div>
      <div class="col-md-4">
        <label class="form-label">{{ 'ContactSpeaker.Materials' | translate}}</label>
        <input type="text" formControlName="materials" class="form-control" id="" >
      </div>
      </div>
    </div>

    <p class="form-label">
      {{'ContactSpeaker.CertificateRadio' | translate}} <span class="color-red">*</span>
    </p>
    <div class="form-group d-flex align-items-center gap-3">
      <div class="form-check">
        <input class="form-check-input" formControlName="certificateRadio" value="Yes" name="certificateRadio" type="radio" id="radioYes">
        <label class="form-check-label" for="radioYes">Yes</label>
      </div>
    
      <div class="form-check">
        <input class="form-check-input" formControlName="certificateRadio" value="No" name="certificateRadio" type="radio" id="radioNo">
        <label class="form-check-label" for="radioNo">No</label>
      </div>
    </div>
    

    <br>
    <h5>{{'ContactSpeaker.EventFormat' | translate}}</h5>
    <hr>

    <div class="form-row" style="display: flex; gap: 10px; margin-bottom: 20px;">

      <div class="form-group"  style="flex: 1;">
        <label class="form-label">{{ 'ContactSpeaker.Introduction' | translate}}</label>
        <input type="text" formControlName="introductionBy" class="form-control" id="" >
      </div>
      <div class="form-group col-md-4">
        <label class="form-label">{{ 'ContactSpeaker.GuestSpeakers' | translate}}</label>
        <input type="text" formControlName="speakers" class="form-control" id="" >
      </div>
      <div class="form-group col-md-4">
        <label class="form-label">{{ 'ContactSpeaker.Attire' | translate}}</label>
        <input type="text" formControlName="attire" class="form-control" id="" >
      </div>

    </div>
    <div class="form-row" style="display: flex; gap: 10px; margin-bottom: 20px;">
      <div class="form-group" style="flex: 1;">
        <label class="form-label">{{ 'ContactSpeaker.DateContacted' | translate}}</label>
        <input type="text" formControlName="dateContacted" placeholder="Select A Date" class="form-control" bsDatepicker [bsConfig]="bsConfig">
      </div>
      <div class="form-group col-md-6">
        <label class="form-label">{{ 'ContactSpeaker.DateConfirmed' | translate}}</label>
        <input type="text" formControlName="dateConfirmed" placeholder="Select A Date" class="form-control" bsDatepicker [bsConfig]="bsConfig">
      </div>
    </div>
    <label class="form-label">{{ 'ContactSpeaker.Comments' | translate}}</label>
    <div class="form-group">

      <textarea class="form-control" formArrayName="description" id="" rows="5"></textarea>
    </div>
    <div class="form-group" style="margin-top: 15px;">
      <re-captcha (resolved)="resolved($event)"
                formControlName="recaptchaReactive"
                siteKey="6LeMhXsaAAAAAJGLeSpf_zsNhZkZm8edYQwKXIwK">
    </re-captcha>
    <div class="invalid-feedback" style="display: block">
      <ng-container *ngIf="hasError('recaptchaReactive', 'required')">{{ 'ContactAssessor.Required' | translate}}</ng-container>
    </div>
    </div>
    <button type="submit" class="btn btn-primary mr-4" style="margin-top: 10px;">Submit</button><span *ngIf="success">Successfully Submitted</span>
  </form>
</div>
